import filter from 'lodash/filter.js';
import find from 'lodash/find.js';
import { useMemo } from 'react';
import { useCallback, useState } from 'react';
import React from 'react';
import { OrgSection } from '../../../api/fetchPurchases.js';
import { pluralPurchases } from '../../../utils/format.js';
import { getHref } from '../../../utils/getHref.js';
import { isNotEmpty } from '../../../utils/isNotEmpty.js';
import { DownloadIcon } from '../../Icons/index.js';
import styles from './Customer.module.scss';
import ReactMarkdown from 'react-markdown';

export type CustomerProps = {
  orgSection: OrgSection | null;
};

const getUrlTitle = (url: string): string => {
  const hostnameMatch = url.match(/^(?:\w+?:\/\/)?([^\/]+)/i);

  return hostnameMatch && hostnameMatch[1] ? hostnameMatch[1] : '';
};

export const Customer: React.FC<CustomerProps> = ({ orgSection }) => {
  const { logo, site, info, docs, videos } = useMemo(
    () => ({
      logo: find(orgSection?.orgPublicProps, ['type', 'logo']),
      site: find(orgSection?.orgPublicProps, ['type', 'site']),
      info: find(orgSection?.orgPublicProps, ['type', 'info']),
      docs: filter(orgSection?.orgPublicProps, ['type', 'doc']),
      videos: filter(orgSection?.orgPublicProps, ['type', 'video']),
    }),
    [orgSection?.orgPublicProps],
  );

  const [showInfo, setShowInfo] = useState(true);

  const toggleState = useCallback(() => {
    setShowInfo(!showInfo);
  }, [showInfo]);

  if (!orgSection?.orgPublicProps) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.leftBlock}>
        {showInfo && isNotEmpty(info) && (
          <div className={styles.info}>
            <ReactMarkdown>{info.value}</ReactMarkdown>
          </div>
        )}
        {!showInfo && (
          <div className={styles.docs}>
            <h2>Документы</h2>
            <ol className={styles.list}>
              {docs.map((doc) => (
                <li key={doc.id} className={styles.item}>
                  <a
                    key={doc.id}
                    href={getHref(doc.edeFile?.url)}
                    download
                    className={styles.link}
                  >
                    {doc.title}
                    <DownloadIcon />
                  </a>
                </li>
              ))}
              {videos.map((doc) => (
                <li key={doc.id} className={styles.item}>
                  <a
                    key={doc.id}
                    href={getHref(doc.value)}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={styles.link}
                  >
                    {doc.title}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
      <div className={styles.rightBlock}>
        {isNotEmpty(logo) && (
          <div className={styles.logo}>
            <img src={getHref(logo.edeFile?.url)} alt="logo" />
          </div>
        )}
        {isNotEmpty(site) && (
          <div className={styles.site}>
            <a
              href={site.value}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {getUrlTitle(site.value)}
            </a>
          </div>
        )}
        <div className={styles.counter}>
          <div className={styles.number}>{orgSection?.announceQuantity}</div>
          <div>{pluralPurchases(orgSection.announceQuantity || 0)}</div>
        </div>
        <button className={styles.button} onClick={toggleState}>
          {showInfo ? 'Документы' : 'О компании'}
        </button>
      </div>
    </div>
  );
};
